/** Pricing Model = Time and Materials. Stored in `employee_department_id`. */
export const PRICING_MODEL_TIME_AND_MATERIALS = 2;

/**
 * The customer's agreed billed labour rate.
 *
 * Reads the real column first and falls back to `employeeFunctionID`, which is
 * where this value used to be written. That is an employee field the billing
 * card was overloading, and it is an INT — so it could never hold a rate with
 * cents. `customer_hourly_rate` is a DECIMAL(10,2) added for the purpose
 * (kalos-core migration 411).
 *
 * The fallback exists so the handful of customers who already have a rate keep
 * showing one, rather than silently dropping to $0 the day this ships. It is
 * only ever reached for Time-and-Materials customers, because that is the only
 * case any of this renders in — which keeps it away from the stale function
 * ids sitting on customers with no pricing model set.
 *
 * Remove the fallback once accounting has confirmed the existing values and
 * they have been copied across. Nothing writes to the old field any more.
 */
export const customerHourlyRate = (customer: {
  customerHourlyRate?: number;
  employeeFunctionID?: number;
}): number => customer.customerHourlyRate || customer.employeeFunctionID || 0;

/** Renders a rate, showing cents only when the rate has them. */
export const formatHourlyRate = (rate: number): string =>
  Number.isInteger(rate) ? `$${rate}` : `$${rate.toFixed(2)}`;
